<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">

      <div class="card">
        <div class="card-body text-center">

          <div class="mb-4">
            <i class="fas fa-times-circle text-danger fa-4x"></i>
          </div>

          <h2 class="text-danger">
            Payment Failed
          </h2>

          <hr>

          <p>
            We were unable to verify your payment.
          </p>

          <p>
            If your card was charged, please contact the church administrator.
          </p>

          <p>
            You may also return to the form and try again.
          </p>

          <button
            class="btn btn-primary mt-3"
            onclick="history.back()">
            Return
          </button>

        </div>
      </div>

    </div>
  </div>
</div>